import React, { useState, useEffect } from 'react'
import { Document, Page } from 'react-pdf'

// const source = 'https://parcoprueba.s3.us-west-2.amazonaws.com/pdf'

const PDF = ({ filename, availableDocuments }) => {
  const [numPages, setNumPages] = useState(0)
  const [documentSize, setDocumentSize] = useState(0)

  const file = availableDocuments[filename]
  const pages = []

  const onDocumentLoadSuccess = ({ numPages }) => setNumPages(numPages)

  const onDocumentLoadFail = err => console.error('Load Error: ', err)

  const onDocumentResize = () => setDocumentSize((window.innerWidth >= 1080) ? 1080 : (window.innerWidth))

  useEffect(() => {
    window.addEventListener('resize', onDocumentResize)
    window.addEventListener('load', onDocumentResize)
  })

  for (let i = 1; i <= numPages; i++) {
    pages.push(
      <Page
        renderTextLayer={false}
        renderMode='svg'
        width={documentSize}
        pageNumber={i}
        key={i}
      />
    )
  }

  return (
    <Document
      file={file}
      onLoadSuccess={onDocumentLoadSuccess}
      onLoadError={onDocumentLoadFail}
      loading={<h1>Cargando</h1>}
    >
      {pages}
    </Document>
  )
}

export default PDF
